import { type FC, useState } from "react";
import Button from "@mui/material/Button";
import { useSnackbar } from "notistack";
import { ConfirmDialog } from "@/admin/shared/ui";
import { useCancelContractMutation } from "@/admin/entities/contracts";

interface CancelContractButtonProps {
  contractId: string;
  onCompleted?: () => void;
}

export const CancelContractButton: FC<CancelContractButtonProps> = ({
  contractId,
  onCompleted,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);

  const [cancelContract, { loading, error }] = useCancelContractMutation({
    onCompleted: () => {
      enqueueSnackbar("Контракт отменён", { variant: "success" });
      setOpen(false);
      onCompleted?.();
    },
    onError: () => {
      // Ошибку показывает ErrorMessage внутри ConfirmDialog.
    },
  });

  return (
    <>
      <Button
        size="small"
        color="error"
        onClick={(event) => {
          event.stopPropagation();
          setOpen(true);
        }}
      >
        Отменить контракт
      </Button>
      <ConfirmDialog
        open={open}
        onCancel={() => setOpen(false)}
        onConfirm={() => void cancelContract({ variables: { id: contractId } })}
        confirmTitle="Отменить контракт"
        confirmText="Неоплаченные платежи по контракту тоже будут отменены. Отменить контракт?"
        loading={loading}
        error={error}
      />
    </>
  );
};
